<template>
  <div class="wrap wrap1">
    <!-- 拖拽排序 -->
    <Card class="box0">
      <span slot="title">拖拽排序</span>
      <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getDoctorsData)">刷新</el-button>
      <div slot="content">
        <vuedraggable class="wrapper" v-model="doctorListSort">
          <transition-group>
            <el-tag v-for="item in doctorListSort" :key="item.doctorId">{{ item.doctorName }}</el-tag>
          </transition-group>
        </vuedraggable>
        <div class="btnwrap">
          <el-button type="success" icon="el-icon-finished" @click="saveGoodDoctorSort">保存排序</el-button>
        </div>
      </div>
    </Card>
    <Card class="box1">
      <span slot="title">名医推荐管理</span>
      <el-button slot="btn" icon="el-icon-refresh" @click="$refresh(getDoctorsData)" >刷新</el-button>
      <div slot="content" class="wrap">
        <!-- 操作按钮 -->
        <div class="button">
          <el-button icon="el-icon-plus" type="primary" @click="adddoctor">新增名医</el-button>
          <el-button icon="el-icon-edit" type="danger" @click="deleteDoctorList">批量删除</el-button>
        </div>
        <!-- 医生列表 -->
        <el-table v-loading="loading" :data="doctorList" ref="multipleTable"
          @selection-change="val => $handleSelectionChange(val, true)" border>
          <el-table-column type="selection" width="50"/>
          <el-table-column type="index" label="序号" width="50"/>
          <el-table-column prop="doctorName" label="医生名称"/>
          <el-table-column prop="updateBy" label="操作员"/>
          <el-table-column prop="createTime" label="创建时间" min-width="150"/>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button icon="el-icon-edit" type="danger" @click="deleteDoctor(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 新增弹框 -->
        <el-dialog class="dialogEdit" title="新增名医" :visible.sync="dialogVisible" width="340px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
          <el-form :model="editForm" ref="editForm" :rules="editFormRules" inline>
            <el-form-item label="医生姓名" prop="doctorId">
              <el-select v-model="editForm.doctorId" placeholder="请选择医生" filterable default-first-option>
                <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                  <span class="fl">{{ item.label }}</span>
                  <span class="select-flex">{{ item.phone }}</span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <!-- 操作按钮 -->
          <span slot="footer" class="dialog-footer">
            <el-button type="success" @click="addSave">保存新增</el-button>
            <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
          </span>
        </el-dialog>
        <!-- 分页 -->
        <el-pagination class="position-s" @current-change="page => $handleCurrentChange(page, getDoctorsData)"
        :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"/>
      </div>
    </Card>
  </div>
</template>

<script lang="js">
import vuedraggable from 'vuedraggable'; // 拖拽组件
import { goodDoctorList, goodDoctorDelete, goodDoctorAdd, goodDoctorDragSort } from "@/api/gooddoctor"; // 名医推荐请求
export default {
  name: "GoodDoctor",
  components: { vuedraggable }, 
  data() {
    return {
      loading: true, // 加载中
      searchForm: {},
      doctorList: [], // 医生列表
      doctorListSort: [], // 医生排序列表
      currentPage: 1, // 当前页
      pageSize: 5, // 显示条数
      total: 0, // 总条数
      dialogTitle: null, // 弹框标题
      dialogVisible: false, // 新增或编辑弹框状态
      editForm: {}, // 新增或编辑表单
      doctorOptions: [], // 医生选项
      multipleSelection: [], // 多选选中数组
      editFormRules: {doctorId: [{required: true, message: "医生姓名不能为空！", trigger: "blur"}]} // 验证规则
    };
  },
  created() {
    this.getGoodDoctorsList(); // 获取名医推荐列表分页
    this.getGoodDoctorsListAll(); // 获取名医推荐列表所有
    this.$getDoctorOptions({type: 0, status: 0, appStatus: 0}); // 获取馆内在职医生，且公众号可查询
  },
  methods: {
    // 请求名医推荐列表
    async getGoodDoctorsList() {
      let params = { pageNum: this.currentPage, pageSize: this.pageSize };
      let { total, rows, code } = await goodDoctorList(params);
      if (code == 200) {
        if (total > 0) rows.forEach(item => { 
          item.doctorName = item.hospDoctorInfo.doctorName;
          this.doctorOptions.forEach((items, i) => {
            if (item.hospDoctorInfo.doctorId == items.value) this.doctorOptions.splice(i, 1);
          });
        });
        this.total = total;
        this.doctorList = rows;
      }
      this.loading = false;
    },
    // 请求所有名医列表
    async getGoodDoctorsListAll() {
      let { rows, code } = await goodDoctorList();
      if (code == 200) {
        rows.forEach(item => { item.doctorName = item.hospDoctorInfo.doctorName })
        this.doctorListSort = rows;
      }
    },
    // 新增医生
    adddoctor() {
      this.editForm = { doctorId: null };
      this.dialogVisible = true;
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          goodDoctorAdd(this.editForm).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("新增名医成功！");

            this.dialogVisible = false;
            this.$refresh(this.getDoctorsData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 删除医生
    deleteDoctor(row) {
      this.$confirm('确认删除该医生？').then(_ => { this.del(row.doctorId) }).catch(_ => {});
    },
    async del(id) {
      let { code } = await goodDoctorDelete(id);
      if (code == 200) this.$message.success("删除医生成功！");
      this.$refresh(this.getDoctorsData);
    },
    // 批量删除医生
    deleteDoctorList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何医生");
      else {
        selected.forEach(item => { selectedId.push(item.doctorId) });
        this.$confirm('确认删除该医生？').then(_ => { this.del(selectedId) }).catch(_ => {});
      }
    },
    // 保存名医排序
    async saveGoodDoctorSort() {
      let { code } = await goodDoctorDragSort(this.doctorListSort);
      if (code == 200) this.$message.success("医生排序成功！");
      this.$refresh(this.getDoctorsData);
    },
    // 重置表单
    reset() {
      this.searchForm = { doctorName: null };
      this.$refresh(this.getDoctorsData);
    },
  },
};
</script>